
/*
 * Overlay
 */


// Global vars
/* global $biro_body */
var $biro_overlay = null;


/**
 * Open overlay
 *
 * @return void
 */
function biro_overlay_open() {

	// Only place overlay if it's not already there
	if ( $biro_overlay === null ) {

		// Flag all top-level elements as inert / hidden from screen readers
		$biro_body.children().each( function() {
			var $el = jQuery( this );
			if ( $el.prop( 'tagName' ) !== 'SCRIPT' ) {
				$el.attr({
					'inert': true,
					'aria-hidden': true
				});
			}
		})

		// Set body / html to position correctly and disable scrolling
		// NOTE: currently a problem when nav menus drop below fold
		//jQuery( 'body,html' ).css( 'height', '100%' );
		//$biro_body.css( 'top', -( document.documentElement.scrollTop ) + 'px' ).addClass( 'no-scroll' );

		// Place overlay, hidden, then fade in
		$biro_overlay = jQuery( '<div class="biro-overlay"></div>' );
		$biro_overlay
			.hide()
			.appendTo( $biro_body )
			.fadeIn( 200 );

	}

	// Add overlay listeners
	$biro_body.on( 'keydown', biro_overlay_close_esc );
	$biro_body.on( 'click', biro_overlay_close_click );

}


/**
 * Close overlay
 *
 * @return {void}
 */
function biro_overlay_close() {

	// Only proceed if overlay exists and not already closing
	if (
		$biro_overlay !== null &&
		! $biro_overlay.hasClass( 'is-closing' )
	) {

		// Add class, fade out, then remove
		$biro_overlay.addClass( 'is-closing' ).fadeOut(
			200,
			function() {
				$biro_overlay.remove();
				$biro_overlay = null;
			}
		);

		// Revert body / html
		jQuery( 'body,html' ).css( 'height', 'unset' );
		$biro_body.removeClass( 'no-scroll' ).css( 'top', 'unset' );

		// Remove overlay listeners
		$biro_body.off( 'keydown', biro_overlay_close_esc );
		$biro_body.off( 'click', biro_overlay_close_click );

		// Restore top-level elements
		$biro_body.children().each( function() {
			var $el = jQuery( this );
			if ( $el.prop( 'tagName' ) !== 'SCRIPT' ) {
				$el.attr({
					'inert': false,
					'aria-hidden': false
				});
			}
		});

		// Trigger overlay close event
		$biro_body.trigger( 'biro:overlay:close' );

	}

}


/**
 * Has escape key been pressed to close?
 *
 * @param {object} e
 *
 * @return {void}
 */
function biro_overlay_close_esc( e ) {

	// Escape key?
	if ( e.key === 'Escape' ) {

		// Close overlay
		biro_overlay_close();

	}

}


/**
 * Has user clicked to close?
 *
 * @param {object} e
 *
 * @return {void}
 */
function biro_overlay_close_click( e ) {

	// Get click target
	var t = jQuery( e.target );

	// Overlay close?
	if ( t.hasClass( 'biro-overlay' ) ) {

		// Close overlay
		biro_overlay_close();

	}

}
